<p-dialog modal="true" appendTo="body" [(visible)]="display" [resizable]="false" (onHide)="onDialogHide()"
		  [style]="{ 'width': '950px' }">

	<p-header>
		<span>Network Sharing</span>
	</p-header>

	<div>
		<share-source [sharedItemGuid]="sharedItemGuid" [sourceUserGuid]="sourceUserGuid"></share-source>
	</div>

	<p-footer>
		<button type="button" pButton icon="fa fa-close" (click)="handleClose()" label="Close"></button>
	</p-footer>

</p-dialog>
